export default __webpack_public_path__ + "static/media/bg33.601a57ad.png";